import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@app/components/components.module';
import { NgModule } from '@angular/core';
import { NotfoundComponent } from '../_index';

@NgModule({
  declarations: [NotfoundComponent],
  imports: [CommonModule, ComponentsModule],
  exports: [NotfoundComponent],
})
export class NotFoundModule {}
